import { combineReducers } from "redux";
import authReducer from "./auth.reducers";
import authUser from "./auth.user.reducer";
import generalReducer from "./general.reducer";

const appReducer = combineReducers({
  auth: authReducer,
  authUser: authUser,
  general: generalReducer,
});
const rootReducer = (state: any, action: any) => {
  //@ts-ignore
  return appReducer(state, action);
};

export default rootReducer;
